export enum HublerPoolRejectionReason {
  IS_EMPLOYEE = 'IS_EMPLOYEE',
  WORKS_WITH_AGENCY = 'WORKS_WITH_AGENCY',
  PREFERS_KNOWN_INSTITUTIONS = 'PREFERS_KNOWN_INSTITUTIONS',
  NO_TIME = 'NO_TIME',
  OTHER = 'OTHER',
}

export enum HubloPoolProfileDeactivationReason {
  NO_SHOW = 'NO_SHOW',
  MISSING_DOCUMENT = 'MISSING_DOCUMENT',
  EXPIRED_RESIDENT_PERMIT = 'EXPIRED_RESIDENT_PERMIT',
  REPEATED_CANCELLATIONS = 'REPEATED_CANCELLATIONS',
  POOLER_REQUEST = 'POOLER_REQUEST',
}
